import i1922 from "@/assets/home/1922.jpg";
import i1924 from "@/assets/home/1924.jpg";
import i1970 from "@/assets/home/1924-1970.jpg";
import i2009 from "@/assets/home/2009.jpg";
import i2016 from "@/assets/home/2016.jpg";
import i2019 from "@/assets/home/2019-revision.jpg";

export default [
  {
    key: 1922,
    info: {
      year: "1922",
      image: i1922,
      description: `Plans begin for construction of the YMCA Army Navy Branch`
    }
  },
  {
    key: 1924,
    info: {
      year: "1924",
      image: i1924,
      description: `The YMCA Armed Services Building opens at 500 West Broadway, San Diego`
    }
  },
  {
    key: 1970,
    info: {
      year: "1924 - 1970",
      image: i1970,
      description: `Millions of soldiers and sailors rest, relax, and celebrate at their "Home Away from Home"`
    }
  },
  {
    key: 2009,
    info: {
      year: "2009 - 2015",
      image: i2009,
      description: `The 500 West Hotel hostel/boutique hotel continues tradition of hospitality at 500 West Broadway`
    }
  },
  {
    key: 2016,
    info: {
      year: "2016",
      image: i2016,
      description: `Construction of The Guild Hotel begins.  Exhaustive efforts are taken to maintain many historic elements of the building, including preserving the running track in the boxing ring turned Grace Ballroom.`
    }
  },
  {
    key: 2019,
    info: {
      year: "2019",
      image: i2019,
      description: `June 7, 2019 The Guild opens as a Tribute Portfolio Hotel beginning another era of hospitality at 500 West Broadway`
    }
  }
];
